<template>
  <el-card class="page-container h-full">
    <TitleBorder title="区域人员统计"></TitleBorder>
    <el-row class="h-33/100">
      <div
          class="flex-wrap flex mt-20px h-5/12"
        >
        <el-card class="items-center border h-full mb-10px relative mr-30px"
              v-for="(item, index) in groupList"
              :key="item.id"
              :ref="`item${index}`"
              @click.native="searchData(item.areaCode, index)"
              :style="{ width: itemWidth + 'px' }"
              :class="isActive(index)"
              shadow="hover">
            <div class="text-20px absolute top-16px right-10px">
                <i class="el-icon-info icon-button-text mr-5px" @click.stop="operate('edit',item)"></i>
                <i class="el-icon-error icon-button-text" @click.stop="operate('delete',item,index)"></i>
            </div>
            <div class="flex align-center justify-between flex-col h-full">
              <div class="text-20px font-bold flex-1 mt-5px active-text"
              >{{ item.name }}</div>
              <div class="flex-1">
                <span class="active-text">实时</span>
                <span class="text-20px text-[#d41819] pl-2px pr-2px">{{ item.realTimeCount }}</span
                >
                <span class="active-text">人</span>
              </div>
            </div>

          </el-card>
          <div
            class="cursor-pointer items-center border w-110px h-full bg-[#d41819] p-10px flex justify-center items-center text-20px text-center rounded-4px"
            @click="operate('add')"
            >
            <!-- <span class="text-20px bold">+</span>
            <span class="text-20px bold">添加</span> -->
            <i class="el-icon-plus text-50px bold text-[#fff]"></i>
          </div>
      </div>
    </el-row>
    <el-row class="bottom h-1/2">
        <div>人员出入状态记录</div>
        <el-divider class="mt-10px"></el-divider>
        <el-form :inline="true" :model="form" ref="form" label-position="left" label-width="40px" class="relative">
            <el-form-item label="状态" prop="status" class="mr-5px">
                <el-select v-model="form.status" placeholder="请选择" clearable>
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="已进入" :value="1"></el-option>
                  <el-option label="已离开" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="人员" prop="searchStr">
               <el-input v-model="form.searchStr" placeholder="请输入人员姓名/编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="departmentSearchStr">
               <el-input v-model="form.departmentSearchStr" placeholder="请输入部门名称/编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间" prop="timeRange">
              <el-date-picker v-model="form.timeRange" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" placeholder="选择时间范围"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
              type="primary"
              @click.native.prevent="() => { searchData() }"
              native-type="submit"
              >搜索</el-button
            >
            <el-button @click="exportFile">导出</el-button>
            <el-button @click="resetForm">重置</el-button>
            </el-form-item>
            <el-button
              type="primary"
              @click="updateStatistics"
              class="absolute right-0 top-0"
              :disabled="!$hasAccess('create')"
              >更新统计</el-button
            >
        </el-form>
        <el-table
            :data="tableData"
            border
            stripe
            height="calc(100% - 80px)"
            v-loading="tableLoading"
        >
            <el-table-column label="区域" prop="areaName" :align="alignType"></el-table-column>
            <el-table-column label="人员编码" prop="personCode" :align="alignType"></el-table-column>
            <el-table-column label="人员姓名" prop="personName" :align="alignType"></el-table-column>
            <el-table-column label="部门" prop="departmentName" :align="alignType"></el-table-column>
            <el-table-column label="状态" prop="status" :align="alignType">
                <template slot-scope="{row}">
                  <span :class="row.status === 1 ? 'text-green-500' : 'text-red-500'">{{row.status === 1 ? '进入' : '离开'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="出入时间" prop="actionTime" :align="alignType">
                <template slot-scope="{row}">
                  {{row.actionTime  ? dayjs(row.actionTime).format('YYYY-MM-DD HH:mm:ss') : ''}}
                </template>
            </el-table-column>
            <el-table-column label="出入设备" prop="gateDeviceName" :align="alignType"></el-table-column>
        </el-table>
        <el-pagination
            class="mt-20px"
            background
            @size-change="searchData"
            @current-change="getList"
            :current-page.sync="initPagination.pageNum"
            :page-size.sync="initPagination.pageSize"
            :total="initPagination.total"
            layout="->,total, sizes, prev, pager, next, jumper"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
        >
        </el-pagination>
    </el-row>
    <EditDialog ref="editDialog"
      :show.sync="show"
      v-if="show"
      :type="operateType"
      :index="operateIndex"
      @reload="getAeraPerson"
      :detailRow="editItem"/>
  </el-card>
</template>

<script>
import { IOTGateAreaRangePersonStatusRecordApi, IOTGateAreaRangeApi } from '@wiz-api/iot-device-management'
// import tableHeightMixin from '@/mixins/tableHeightMixin'
import TitleBorder from '@/components/TitleBorder'
import FnMixins from '@/assets/js/fnMixins'
import EditDialog from './EditDialog'

const iotGateAreaRangeApi = new IOTGateAreaRangeApi()
const iotGateAreaRangePersonStatusRecordApi = new IOTGateAreaRangePersonStatusRecordApi()
export default {
  name: 'personStatisticsPanel',
  components: { TitleBorder, EditDialog },
  mixins: [FnMixins],
  computed: {
    itemWidth() {
      const itemCount = this.groupList.length + 1 <= 12 ? 12 : this.groupList.length + 1
      const gap = 30 // 假设每个元素之间的间距为 30px
      const totalGap = gap * itemCount // 总间距
      const availableWidth = (this.containerWidth) * 2 - totalGap // 可用的宽度
      return availableWidth / itemCount // 每个元素的宽度
    },
    isActive() {
      return (index) => {
        if (index === this.activeIndex) {
          return 'area-active'
        }
        return 'area-deactive'
      }
    }
  },
  data() {
    return {
      containerWidth: 1580,
      areaId: '',
      areaCode: '',
      prAreaIndex: 0,
      activeIndex: 0,
      show: false,
      operateType: '',
      operateIndex: 0,
      editItem: {},
      groupList: [],
      alignType: 'left',
      form: {},
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 页面初始化
    async init() {
      await this.getAeraPerson(0)
      //   await this.getList()
      // this.$nextTick(() => {
      //   this.$refs.item0[0].classList.add('area-active')
      // })
    },
    async getAeraPerson(index = 0) {
      const [err, res] = await iotGateAreaRangeApi.getAreaRangeStatisticsAsyunc()
      if (!err) {
        this.groupList = res.areaRangeStatisticInfos
        // this.areaId = this.groupList[index].id
        this.areaCode = this.groupList[index].areaCode
        this.prAreaIndex = index
        this.getList()
      }
    },
    operate(type, item, index) {
      if (type === 'edit' || type === 'add') {
        this.operateType = type
        this.editItem = item || {}
        this.show = true
      }
      if (type === 'delete') {
        this.$confirm('是否确定删除?')
          .then(async () => {
            // 删除操作
            const [err, res] = await iotGateAreaRangeApi.deleteAreaRange(item.id, { id: item.id })
            if (!err) {
              this.$message.success('删除成功')
              let tempIndex = 0
              if (this.operateIndex > index) {
                tempIndex = this.operateIndex - 1
              } else if (this.operateIndex < index) {
                tempIndex = this.operateIndex
              } else {
                tempIndex = 0
                this.$refs.item0[0].classList.add('area-active')
              }
              this.getAeraPerson(tempIndex)
            }
          })
          .catch(() => {})
      }
    },
    // 根据搜索条件搜索数据
    searchData(areaCode = '', index) {
      if (areaCode) {
        this.areaCode = areaCode
      }
      if (index || index === 0) {
        this.activeIndex = index
      }
      this.operateIndex = index
      this.initPagination.pageNum = 1
      this.getList()
    },
    // 获取表单数据
    async getList() {
      const params = {
        ...this.form,
        areaCode: this.areaCode,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      }
      delete params.timeRange
      if (this.form.timeRange && this.form.timeRange?.length > 0) {
        params.startTime = this.form.timeRange[0]
        params.endTime = this.form.timeRange[1]
      }
      this.tableLoading = true
      const [err, res] = await iotGateAreaRangePersonStatusRecordApi.getPageList(params)
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items || []
        this.initPagination.total = res.totalCount
      }
    },
    // 导出
    exportFile() {
      this.$confirm('是否确定导出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          // 导出操作
          const params = {
            ...this.form,
            areaCode: this.areaCode,
          }
          const [err, res] = await iotGateAreaRangePersonStatusRecordApi.exportToExcelFile(params)
          if (!err) {
            this.downLoadBlob({
              name: '人员出入状态记录.xlsx',
              data: res,
            })
          }
        })
        .catch(() => {})
    },
    async updateStatistics() {
      const [err, res] = await iotGateAreaRangeApi.updateStatistics()
      if (!err) {
        this.$message.success('更新成功')
        this.getAeraPerson(this.operateIndex)
      }
    },
    // 重置筛选条件
    resetForm() {
      this.form = {}
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}

::v-deep .area-active {
  position: relative;
  border: none;
  transform: translateY(-2px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(212, 24, 25, 0.15);

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #d41819;
  }

  .el-card__body {
    border: none;
  }

  .active-text {
    color: #d41819;
  }
}

::v-deep .el-card {
  cursor: pointer;
  transition: all 0.3s ease;
  // border: 1px solid #ebeef5;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .icon-button-text {
    cursor: pointer;
    display: inline-block;
    color: rgb(217, 217, 217);
    transition: color 0.3s ease;

    &:hover {
      color: #d41819;
    }
  }

  .el-card__body {
    padding: 10px;
  }
}
</style>
